import clsx from "clsx";
import { ExclamationCircleIcon } from "@heroicons/react/24/outline";

export default function TextArea({
  onChange,
  register,
  error,
  rows = 6,
  ...others
}) {
  return (
    <div>
      <div className="relative">
        <textarea
          className={clsx(
            "border-none focus:outline-inputFocused outline-secondaryBorder disabled:bg-secondaryHover placeholder-inputPlaceholder text-inputText outline outline-1 focus:outline-2 w-full px-3 py-2 rounded-lg shadow-[0px_1px_2px_0px_rgba(10,13,18,0.05)] text-base font-normal disabled:cursor-not-allowed",
            {
              "focus:!outline-inputIconError !outline-inputBorderError pr-10":
                error,
            }
          )}
          onChange={onChange}
          rows={rows}
          {...others}
          {...(register ? register(others?.name, { onChange }) : {})}
        />

        {error && (
          <ExclamationCircleIcon className="size-6 text-inputIconError absolute right-2 top-1/2 -translate-y-1/2" />
        )}
      </div>

      {error && (
        <div className="mt-2">
          <p className="m-0 p-0 text-inputTextError text-sm font-normal leading-tight">
            {error}
          </p>
        </div>
      )}
    </div>
  );
}
